import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: "us-east-1_0PQKAPWws",
    ClientId: "1v70ktldmsmigbgssku024ecan"
}

export default new CognitoUserPool(poolData)